import {connect} from 'react-redux';
import {ScheduleCallbackPage} from 'src/pages/scheduleCallback/components/ScheduleCallbackPage';
import {
  setDay,
  setEmail,
  setIntent,
  setPhone,
  setTimeslot,
} from 'src/pages/scheduleCallback/store/actions/app';
import {cancelAppointmentStep} from 'src/pages/scheduleCallback/store/actions/cancelAppointmentStep';
import {selectIntentStep} from 'src/pages/scheduleCallback/store/actions/selectIntentStep';
import {selectTimeslotStep} from 'src/pages/scheduleCallback/store/actions/selectTimeslotStep';
import {submitCancelAppointment} from 'src/pages/scheduleCallback/store/actions/submitCancelAppointment';
import {submitIntent} from 'src/pages/scheduleCallback/store/actions/submitIntent';
import {submitTimeslot} from 'src/pages/scheduleCallback/store/actions/submitTimeslot';
import {launchXfinityAssistant} from 'src/shared/xfinityAssistant/actions';
import {
  appointment,
  availableIntents,
  availableTimes,
  day,
  email,
  flow,
  intent,
  outageMessage,
  phone,
  timeslot,
  timeslots,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {
  billPay,
  moving,
  myAccount,
} from 'src/shared/config/urls';
import {
  delinquent,
  dueDate,
  eligibleForPromiseToPay,
  inSoftDisconnect,
  pastDueBalance,
} from 'src/shared/currentBillSummary/selectors';
import {currentView} from 'src/shared/currentView/selectors';
import {
  home,
  repairInternet,
  repairTv,
  status,
} from 'src/shared/pagePaths';
import {
  redirect,
  reload,
} from 'src/shared/redirect/actions';
import {continueUrl} from 'src/shared/redirect/selectors';
import {hasOutageMessagesSegment} from 'src/shared/datacast/selectors';

const mapStateToProps = state => ({
  amountDue: pastDueBalance(state),
  appointment: appointment(state),
  availableIntents: availableIntents(state),
  availableTimes: availableTimes(state),
  billPayUrl: billPay(state),
  continueUrl: continueUrl(state),
  currentView: currentView(state),
  day: day(state),
  delinquent: delinquent(state),
  eligibleForPromiseToPay: eligibleForPromiseToPay(state),
  email: email(state),
  flow: flow(state),
  hasOutageMessagesSegment: hasOutageMessagesSegment(state),
  inSoftDisconnect: inSoftDisconnect(state),
  intent: intent(state),
  movingUrl: moving(state),
  outageMessage: outageMessage(state),
  payByDate: dueDate(state),
  phone: phone(state),
  timeslot: timeslot(state),
  timeslots: timeslots(state),
});

const redirectWithSelector = urlSelector => (dispatch, getState) =>
  dispatch(redirect(urlSelector(getState())));

const mapDispatchToProps = dispatch => ({
  onBillPay: () => dispatch(redirectWithSelector(billPay)),
  onCancel: () => dispatch(redirect()),
  onCancelCallback: () => dispatch(cancelAppointmentStep()),
  onComplete: () => dispatch(redirect()),
  onConfirmCancel: () => dispatch(submitCancelAppointment()),
  onConfirmIntent: () => dispatch(submitIntent()),
  onDayChange: day => dispatch(setDay(day)),
  onEmailChange: email => dispatch(setEmail(email)),
  onGetCall: () => dispatch(selectTimeslotStep()),
  onInternetRepair: () => dispatch(redirect(repairInternet())),
  onMyAccount: () => dispatch(redirectWithSelector(myAccount)),
  onMoving: () => dispatch(redirectWithSelector(moving)),
  onPhoneChange: phone => dispatch(setPhone(phone)),
  onScheduleCall: () => dispatch(selectIntentStep()),
  onSelectIntent: intent => dispatch(setIntent(intent)),
  onStatusCenter: () => dispatch(redirect(status())),
  onSubmit: () => dispatch(submitTimeslot()),
  onSupport: () => dispatch(redirect(home())),
  onTimeslotChange: timeslot => dispatch(setTimeslot(timeslot)),
  onTryAgain: () => dispatch(reload()),
  onTvRepair: () => dispatch(redirect(repairTv())),
  onLaunchXfinityAssistant: intent => dispatch(launchXfinityAssistant(undefined /* no utterance */, intent)),
});

export const App = connect(mapStateToProps, mapDispatchToProps)(ScheduleCallbackPage);
